import { Suspense, lazy } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { createStore, applyMiddleware, combineReducers } from "redux";
import { Provider } from "react-redux";
import createSagaMiddleware from "redux-saga";
import { ToastContainer } from "react-toastify";

import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/style.css";
import "./assets/css/custom.css";
import "react-toastify/dist/ReactToastify.css";

import AuthReducer from "./store/reducers/auth";
import { rootSaga } from "./store/sagas";
import Loader from "./Layouts/Loader";
import Home from "./Components/Pages/Home";
import ProtectedRoute from "./Utils/ProtectedRoute";
const Details = lazy(() => import("./Components/Pages/Invoice/Details"));
const Invoices = lazy(() => import("./Components/Pages/Invoice"));

const rootReducer = combineReducers({
  auth: AuthReducer,
});

const sagaMiddleware = createSagaMiddleware();

const store = createStore(rootReducer, applyMiddleware(sagaMiddleware));
sagaMiddleware.run(rootSaga);

function App() {
  return (
    <Provider store={store}>
      <Suspense fallback={<Loader />}>
        <Router basename={process.env["REACT_APP_BASENAME"]}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/q" element={<Home />} />
            <Route path="/invoice/:invoiceId" element={<Home />} />
            <Route path="/invoices" element={<ProtectedRoute><Invoices /></ProtectedRoute>} />
            <Route path="/invoices/details/:invoiceId" element={<Details />} />
            <Route path="/details/:invoiceId" element={<Details />} />
            <Route path="/splash" element={<Loader />} />
            <Route path="/:invoiceId" element={<Home />} />
          </Routes>
          <ToastContainer position="top-center" />
        </Router>
      </Suspense>
    </Provider>
  );
}

export default App;
